import Papa from 'papaparse'

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const usernameRegex = /^[a-zA-Z0-9._-]+$/

const validator = (file) => {
  return new Promise((resolve) => {
    let row = 0
    let headers = []
    let hasUserRow = false
    Papa.parse(file, {
      worker: true,
      delimiter: ',',
      step: ({ data, errors }, parser) => {
        if (row === 0) {
          // check required headers are present
          if (!data.includes('Email') && !data.includes('Username') && !data.includes('cognitoUsername')) {
            console.debug('CSV Validation aborted')
            resolve({
              code: 'missing-field',
              message: 'CSV is missing the required "Email" or "Username" header.'
            })
            parser.abort()
          }
          headers = data
        } else {
          // skip empty rows
          const skip = data.every(v => !v?.trim())
          const rowNum = row + 1
          const rowData = headers.reduce((acc, header, index) => {
            acc[header] = data[index]
            return acc
          }, {})
          const { Email: email, Username: username } = rowData

          // Check Email format
          if (email && !emailRegex.test(email)) {
            console.debug('CSV Validation aborted')
            resolve({
              code: 'invalid-email',
              message: `Invalid email on row ${rowNum}: ${email} does not use a valid email format.`
            })
            parser.abort()
          }
          // Check Username format
          if (username && !usernameRegex.test(username)) {
            const allowedUsernameChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._-'
            const invalidUsernameChars = [...username].filter((ch) => !allowedUsernameChars.includes(ch))
            if (invalidUsernameChars.length > 0) {
              console.debug('CSV Validation aborted')
              resolve({
                code: 'invalid-username',
                message: `Invalid username on row ${rowNum}: ${username} cannot contain the following invalid character(s): '${invalidUsernameChars.join(
                  "', '"
                )}'.`
              })
              parser.abort()
            } else {
              resolve({
                code: 'invalid-username',
                message: `Invalid username on row ${rowNum}: ${username} contains disallowed characters.`
              })
              parser.abort()
            }
          }
          if (!skip) {
            hasUserRow = true
          }
        }
        row++
        if (errors.length) {
          console.debug('CSV Validation failed', errors)
          resolve({
            code: errors[0].code,
            message: errors[0].message
          })
          parser.abort()
        }
      },
      complete: () => {
        if (!hasUserRow) {
          resolve({
            code: 'missing-users',
            message: 'CSV must contain at least one user.'
          })
          return
        }
        console.debug('CSV Validation complete')
        resolve(row)
      }
    })
  })
}

export default validator
